<template>
  <div class="product-center-page">
    <div class="product-center-content">
      <div class="product-center-title">
        <h1 class="main-title">{{ $t('productCenter.title') }}</h1>
        <!-- <div class="desc">{{ $t('productCenter.subtitle') }}</div> -->
      </div>

      <div class="tabs">
        <div v-for="(tab, idx) in tabs" :key="tab.key" :class="['tab', { active: currentTab === idx }]"
          @click="handleTabClick(idx)">
          {{ tab.label }}
        </div>
      </div>
      <div class="product-grid" v-show="showTag === 0">
        <div v-for="item in tabs[0].products" :key="item.title" class="product-card">
          <div class="img-wrapper">
            <img :src="item.img" :alt="item.title" />
          </div>
          <div class="product-title">{{ item.title }}</div>
        </div>
      </div>
      <div class="product-grid" v-show="showTag === 1">
        <div v-for="item in tabs[1].products" :key="item.title" class="product-card">
          <div class="img-wrapper">
            <img :src="item.img" :alt="item.title" />
          </div>
          <div class="product-title" :class="{ 'active-title': selectedProductTitle === item.title }">{{ $t(item.title) }}</div>
        </div>
      </div>
      <div class="product-grid" v-show="showTag === 2">
        <div v-for="item in tabs[2].products" :key="item.title" class="product-card">
          <div class="img-wrapper">
            <img :src="item.img" :alt="item.title" />
          </div>
          <div class="product-title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n' // 新增：引入i18n

const route = useRoute()
const router = useRouter()
const { tm } = useI18n() // 新增：获取i18n的tm方法（用于获取嵌套数组）

// ✅ 正确做法：computed 包装 tm，变成响应式
const tabs = computed(() => tm('productCenter.tabs'))

const currentTab = ref(0)
const showTag = ref(0) // ⚠️ 改为响应式的 ref，而不是 var

onMounted(() => {
  const tabIndex = Number(route.query.tab)
  if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < tabs.value.length) {
    currentTab.value = tabIndex
    showTag.value = tabIndex
  }
})

const handleTabClick = (index) => {
  currentTab.value = index
  showTag.value = index
  router.push({ path: '/product', query: { tab: index } })
}

watch(() => route.query.tab, (newTab) => {
  const tabIndex = Number(newTab)
  if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < tabs.value.length) {
    currentTab.value = tabIndex
    showTag.value = tabIndex
  }
})

</script>

<style scoped>
.product-center-content {
  position: relative;
  width: 100%;
  /* margin-top: var(--header-height, 80px); */
  padding-bottom: 60px;
  background: #fff;
  margin-bottom: 50px;
}

.product-center-title {
  background: #f7f7f7;
  padding: 24px 0 24px 0;
}

.main-title {
  text-align: center;
  font-size: 2.2rem;
  font-weight: bold;
  margin-bottom: 40px;
  position: relative;
}

.main-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background-color: #ff7f1a;
}

.desc {
  text-align: center;
  line-height: 2;
  font-size: 16px;
  color: #666;
  margin-bottom: 30px;
}

.tabs {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  gap: 4vw;
}

.tab {
  background: #fff;
  border: 1px solid #eee;
  padding: 12px 56px;
  /* 需要适配 */
  font-size: 1.1rem;
  cursor: pointer;
  color: #222;
  border-radius: 4px 4px 0 0;
  transition: all 0.2s;
  font-weight: bold;
}

.tab.active {
  background: #ff7f1a;
  color: #fff;
  border-bottom: 2px solid #ff7f1a;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2vw;
  width: 80vw;
  margin: 0 auto;
}

.product-card {
  display: flex;
  flex-direction: column;
  /* 需要适配 */
  width: 18vw;
  border-radius: 2px;
  background: #fff;
  margin: 0 auto;
  transition: transform 0.3s ease;
  border: solid 1px #dbdbdb;
}

.product-card:hover {
  transform: scale(1.05);
}

.product-card:hover .product-title{
  background-color: #ff7f1a;
}

.img-wrapper {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}

.product-card img {
  width: 100%;
  height: 100%;
  display: block;
  background: transparent;
}

.product-title {
  width: 100%;
  background: #f7f7f7;
  padding: 16px 0;
  /* 需要适配 */
  font-size: 1.1rem;
  color: #222;
  box-sizing: border-box;
  text-align: center;
  flex-shrink: 0;
}



/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  .main-title {
    font-size: 2.4rem;
  }

  .desc {
    line-height: 2.2;
    font-size: 1.4rem;
  }

  .tab {
    font-size: 1.4rem;
  }

  .product-grid {
    width: 80vw;
  }

  .product-card {
    width: 18vw;
  }

  .product-title {
    font-size: 1.4rem;
  }

  .main-title::after {
    width: 80px;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .main-title {
    font-size: 2.2rem;
  }

  .desc {
    line-height: 2;
    font-size: 1.2rem;
  }

  .tab {
    font-size: 1.2rem;
  }

  .product-grid {
    /* 需要适配 */
    width: 85vw;
  }

  .product-card {
    /* 需要适配 */
    width: 19vw;
  }

  .product-title {
    font-size: 1.2rem;
  }
  .main-title::after {
    width: 70px;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .main-title {
    font-size: 2rem;
  }

  .desc {
    line-height: 1.8;
    font-size: 1rem;
  }

  .tab {
    font-size: 1rem;
    padding: 5px 40px;
  }

  .product-grid {
    /* 需要适配 */
    width: 95vw;
  }

  .product-card {
    /* 需要适配 */
    width: 19vw;
  }

  .product-title {
    font-size: 1rem;
  }
  .main-title::after {
    width: 60px;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .main-title {
    font-size: 1.8rem;
  }

  .desc {
    line-height: 1.6;
    font-size: 0.8rem;
  }

  .tab {
    font-size: 0.8rem;
    padding: 5px 20px;
  }

  .product-grid {
    /* 需要适配 */
    width: 95vw;
  }

  .product-card {
    /* 需要适配 */
    width: 21vw;
  }

  .product-title {
    font-size: 0.8rem;
  }
  .main-title::after {
    width: 50px;
  }
}
</style>